<template>
  <el-table :data="table" height="300" style="width: 100%">
    <el-table-column v-for="item in header" :key="item" :prop="item" :label="item"> </el-table-column>
    <el-table-column prop="人选" label="人选">
      <template slot-scope="scope">
        <span style="color:#409eff;cursor:pointer;" @click="showRadish(scope.row)">{{ scope.row.人选 }}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="type === '推荐'" label="是否有最终版推荐报告">
      <template slot-scope="scope">
        <span
          v-if="scope.row.推荐人选 && scope.row.推荐人选.已绑定推荐报告 && scope.row.推荐人选.已绑定推荐报告.length > 0"
          style="color:#67C23A"
        >
          有附件
        </span>
        <el-tooltip effect="dark" content="您是否没有发邮件给客户公司，请补充" placement="top-start">
          <span
            v-if="
              !scope.row.推荐人选 ||
                !scope.row.推荐人选.已绑定推荐报告 ||
                scope.row.推荐人选.已绑定推荐报告.length === 0
            "
            style="color:#F56C6C"
          >
            无附件</span
          >
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="日期" label="日期"> </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    table: { type: Array, default: () => [] },
    type: { type: String, defalult: '' },
  },
  data() {
    return {
      header: ['客户公司', '部门', '项目名称'],
    }
  },
  methods: {
    showRadish(val) {
      window.open(`${window.frontend}/#/radish-detail-blank/${val.rid}`, '_blank')
    },
  },
}
</script>
